import Registry from 'live/services/registry'
import React from 'react'

type KpisDrillingRegistryComponent = {
    state: Record<string, unknown>
    props: Record<string, unknown>
}

type KpisDrillingRegistry = {
    id: string
    Component: React.ComponentType<KpisDrillingRegistryComponent>
}

export const KpisDrillingRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}

export function componentExtractor(registry: KpisDrillingRegistry): React.ComponentType<KpisDrillingRegistryComponent> {
    return registry?.Component
}

// Realtime
export const KpisDrillingRealTimeHeaderTitleRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}
export const KpisDrillingRealTimeSectionRowRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}
export const KpisDrillingRealTimeSectionRowStatusRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}

// Reprocess
export const KpisDrillingReprocessHeaderTitleRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}
export const KpisDrillingReprocessSectionRowRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}
export const KpisDrillingReprocessSectionRowStatusRegistryService = {
    registry: new Registry<KpisDrillingRegistry>()
}
